import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Header */}
      <section className="bg-[#003366] text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-4xl font-bold">Terms of Service</h1>
          <p className="text-white/70 mt-2">Last Updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg max-w-none">
          
          <p className="text-gray-700 leading-relaxed">
            Welcome to Valenrock™ Home Services. By accessing or using our website and services, you agree to be bound by these Terms of Service. Please read them carefully.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700">
            By accessing our website or using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree, please do not use our services.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">2. Services Description</h2>
          <p className="text-gray-700">
            Valenrock™ Remodelers, LLC, doing business as Valenrock™ Home Services, provides home assessment, maintenance planning, and remodeling services in Northern and Central New Jersey, including Bergen, Hudson, Essex, Passaic, Morris, Sussex, Somerset, Union, and Middlesex Counties. Our services include:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Whole-Home Assessments</li>
            <li>Personalized Home Profiles</li>
            <li>Maintenance planning and coordination</li>
            <li>Remodeling and renovation services</li>
            <li>Vendor and contractor coordination</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">3. Service Area</h2>
          <p className="text-gray-700">
            Our services are currently available in Northern and Central New Jersey, including Bergen, Hudson, Essex, Passaic, Morris, Sussex, Somerset, Union, and Middlesex Counties. Service availability may vary by location and is subject to change.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">4. Pricing and Payment</h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Assessment pricing starts at $249 for single-family homes</li>
            <li>Final pricing is confirmed after initial consultation based on property size and complexity</li>
            <li>Payment terms will be communicated prior to service delivery</li>
            <li>All prices are subject to change without notice</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">5. Scheduling and Cancellations</h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Appointments should be cancelled at least 24 hours in advance</li>
            <li>We reserve the right to reschedule appointments due to weather or unforeseen circumstances</li>
            <li>Repeated no-shows may result in service limitations</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">6. User Responsibilities</h2>
          <p className="text-gray-700">When using our services, you agree to:</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Provide accurate and complete information</li>
            <li>Ensure safe access to your property for assessments</li>
            <li>Disclose known issues or hazards on your property</li>
            <li>Use our website and services lawfully</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">7. Intellectual Property</h2>
          <p className="text-gray-700">
            All content on this website, including text, graphics, logos, and images, is the property of Valenrock™ Remodelers, LLC and is protected by copyright and trademark laws. You may not reproduce, distribute, or use our content without written permission.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">8. Limitation of Liability</h2>
          <p className="text-gray-700">
            To the fullest extent permitted by law, Valenrock™ Remodelers, LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services or website.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">9. Indemnification</h2>
          <p className="text-gray-700">
            You agree to indemnify and hold harmless Valenrock™ Remodelers, LLC, its officers, employees, and agents from any claims, damages, or expenses arising from your use of our services or violation of these terms.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">10. Governing Law</h2>
          <p className="text-gray-700">
            These Terms of Service shall be governed by and construed in accordance with the laws of the State of New Jersey, without regard to conflict of law principles.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">11. Dispute Resolution</h2>
          <p className="text-gray-700">
            Any disputes arising from these terms or our services shall first be attempted to be resolved through good-faith negotiation. If unsuccessful, disputes shall be resolved through binding arbitration in New Jersey.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">12. Changes to Terms</h2>
          <p className="text-gray-700">
            We reserve the right to modify these Terms of Service at any time. Changes will be effective upon posting to this page. Your continued use of our services constitutes acceptance of any changes.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-8 mb-4">13. Contact Information</h2>
          <p className="text-gray-700">
            For questions about these Terms of Service, please contact us:
          </p>
          <div className="bg-gray-50 p-4 rounded-lg mt-4">
            <p className="text-gray-700"><strong>Valenrock™ Remodelers, LLC d/b/a Valenrock™ Home Services</strong></p>
            <p className="text-gray-700">Email: contact@valenrockhome.services</p>
            <p className="text-gray-700">Phone: (551) 379-9774</p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link to="/" className="text-[#003366] hover:text-[#CFB973] font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
